
import React from 'react';
import { booleanTestIdFormatter } from "../../../utils/helpers";
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { find as lodashFind } from 'lodash';
import cbModal from '../../Modal/Modal'
import NotifyOnChangeModal from "./NotifyOnChangeModal";

const GlobalFieldTitleToggle = ({ parentInfo, uniqueKey, field_metadata, onchange, testId, multiple, schema, contentTypeSchemaTree = [], isGlobalFieldBuilderPage = false }) => {
  const formattedTestId = booleanTestIdFormatter(testId, field_metadata.is_global_field_instance_title);
  const selectFieldTypes = ['dropdown', 'radio', 'checkbox']

  const handleChange = (event) => {
    const prevGlobalTitle = lodashFind(contentTypeSchemaTree, (singleField) => {
      if (singleField.field_metadata && singleField.field_metadata.is_global_field_instance_title && singleField.uid !== schema.uid) {
          return true;
      }
    });

    if(prevGlobalTitle){
      cbModal({
        component: (propsData: any) => (
          <NotifyOnChangeModal {...propsData} data={{ description: `Currently the <b>${prevGlobalTitle.display_name}</b> field is already marked as a global title field. Do you want to make this field as a global title, instead?` }} handleSubmit={(data)=>{
            if(data){
              // Remove the global title flag from the previous field
              delete prevGlobalTitle?.field_metadata?.is_global_field_instance_title;
              // Set the global title flag on the new field
              field_metadata.is_global_field_instance_title = true;
              // Trigger the state update to reflect changes in contentTypeSchemaTree
              onchange();
            }
          }}/>
        ),
        modalProps: { size: 'small' }
      })
    }else{
      const eventData = event.target.checked
      field_metadata.is_global_field_instance_title = eventData
      onchange();
    }
  }

  const shouldRender = (selectFieldTypes.includes(schema.display_type) || !multiple) && isGlobalFieldBuilderPage && parentInfo.data_type !== 'blocks' && parentInfo.data_type !== 'group'

    // && parentInfo.hasParent &&
    // parentInfo.isMulti &&
    // (parentInfo.data_type === 'global_field');

  if (!shouldRender) return null;

  return (
    <div className="mark-group-title">
      <div className='ToggleWrap'>
        <ToggleSwitch
          testId={formattedTestId}
          name={`${uniqueKey}.isTitle`}
          label="Mark as Global field title"
          checked={field_metadata.is_global_field_instance_title || false}
          onChange={handleChange}
          labelPosition="right"
          labelColor="secondary"
        />
      </div>
    </div>
  )
}

export default GlobalFieldTitleToggle;
